export const PAYMENT_METHOD_OPTION_LIST = [
  {
    value: 'bank_transfer',
    label: '银行转账',
  },
  {
    value: 'dtc',
    label: 'DTC',
  },
  {
    value: 'other',
    label: '其他',
  },
];
